(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
 document.addEventListener('DOMContentLoaded',()=>{const hash=window.location.hash;if(!hash)return;try{const element=document.getElementById(decodeURIComponent(hash.slice(1)));if(element&&element.closest('results-list'))element.scrollIntoView({block:'center'});}catch{}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
 'use strict';
 if (customElements.get('ps-announcements')) return;
 class PatinaAnnouncements extends HTMLElement {
  connectedCallback() {
   if(this.controller)return;
   this.track=this.querySelector('[data-ann-track]');
   this.group=this.querySelector('[data-ann-group]');
   this.viewport=this.querySelector('[data-ann-viewport]');
   this.toggle=this.querySelector('[data-ann-toggle]');
   if(!this.track||!this.group||!this.viewport||!this.toggle)return;
   this.controller=new AbortController();
   const opts={signal:this.controller.signal};
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.userPaused=false;this.editing=false;this.clones=[];
   this.measure=()=>{
    cancelAnimationFrame(this.frame);
    this.frame=requestAnimationFrame(()=>this.updateTrack());
   };
   this.sync=()=>{
    const rolling=this.dataset.rolling==='true'&&!this.reduced.matches&&!this.editing;
    this.classList.toggle('is-rolling',rolling);
    this.classList.toggle('is-paused',this.userPaused||document.hidden);
    this.toggle.hidden=!rolling;
    this.toggle.setAttribute('aria-pressed',String(this.userPaused));
    this.toggle.setAttribute('aria-label',this.userPaused?this.dataset.resumeLabel:this.dataset.pauseLabel);
    this.toggle.querySelector('[data-ann-toggle-text]').textContent=this.userPaused?this.dataset.resume:this.dataset.pause;
    this.measure();
   };
   this.toggle.addEventListener('click',()=>{this.userPaused=!this.userPaused;this.sync();},opts);
   this.reduced.addEventListener('change',this.sync,opts);
   document.addEventListener('visibilitychange',this.sync,opts);
   document.addEventListener('shopify:block:select',event=>{if(this.contains(event.target)){this.editing=true;this.sync();}},opts);
   document.addEventListener('shopify:block:deselect',()=>{if(this.editing){this.editing=false;this.sync();}},opts);
   if('ResizeObserver' in window){
    this.observer=new ResizeObserver(this.measure);
    this.observer.observe(this.viewport);
    this.observer.observe(this.group);
   }else window.addEventListener('resize',this.measure,opts);
   if(document.fonts){
    document.fonts.ready.then(()=>{if(!opts.signal.aborted)this.measure();});
   }
   this.sync();
  }
  updateTrack() {
   if(!this.isConnected||!this.classList.contains('is-rolling'))return;
   const width=this.group.getBoundingClientRect().width;
   const viewportWidth=this.viewport.clientWidth;
   if(width<=0||viewportWidth<=0)return;
   const distance=`${width}px`;
   if(this.style.getPropertyValue('--ps-ann-distance')!==distance){
    this.style.setProperty('--ps-ann-distance',distance);
   }
   // Repeat enough complete sequences to cover any viewport throughout a loop.
   const needed=Math.max(1,Math.ceil(viewportWidth/width)+1);
   while(this.clones.length>needed)this.clones.pop().remove();
   while(this.clones.length<needed){
    const clone=this.group.cloneNode(true);
    clone.removeAttribute('data-ann-group');
    clone.setAttribute('data-ann-clone','');
    clone.setAttribute('aria-hidden','true');
    clone.setAttribute('inert','');
    [clone,...clone.querySelectorAll('*')].forEach(node=>{
     node.removeAttribute('id');
     node.removeAttribute('data-shopify-editor-block');
    });
    this.track.append(clone);
    this.clones.push(clone);
   }
  }
  disconnectedCallback(){
   this.controller?.abort();this.controller=null;
   this.observer?.disconnect();cancelAnimationFrame(this.frame);
   this.clones?.forEach(clone=>clone.remove());this.clones=[];
   this.style.removeProperty('--ps-ann-distance');
   this.classList.remove('is-rolling','is-paused');
  }
 }
 customElements.define('ps-announcements',PatinaAnnouncements);
})();

  } catch(e) { console.error(e); }
})();
})();
